import './VifScoreboard.scss';

export interface VifScoreboardProps {
  round: number;
  /** `null` hides the field, as legacy `scoreboard.updateGame(null)` does. */
  game: number | null;
}

/**
 * The round and game readout, rebuilt in the DOM from the `GameFrame`
 * scoreboard's progress panel (`Scoreboard.updateRound` / `updateGame`). The
 * canvas panel also carries a progress meter and the music button, both of
 * which every VIF board hides (`scoreboard.hideMeter()` /
 * `hideMusicButton()`), so only the two numbers are rebuilt here.
 */
export function VifScoreboard({ round, game }: VifScoreboardProps) {
  return (
    <div className="vif-scoreboard" data-testid="vif-scoreboard">
      <VifScoreboardField label="Round" value={round} />
      {game === null ? null : <VifScoreboardField label="Game" value={game} />}
    </div>
  );
}

interface VifScoreboardFieldProps {
  label: string;
  value: number;
}

function VifScoreboardField({ label, value }: VifScoreboardFieldProps) {
  return (
    <span className="vif-scoreboard__field">
      <span className="vif-scoreboard__label">{label}</span>{' '}
      <span className="vif-scoreboard__value">{value}</span>
    </span>
  );
}
